<template>
  <artmisads-modal
    :visible="visible"
    title="Add New Tracking ID"
    :width="600"
    :footer="null"
    @cancel="handleCancel"
    @update:visible="handleVisibleChange"
  >
    <a-form :model="form" layout="vertical">
      <a-form-item label="Primary ID" :required="true" :validate-status="primaryIdError ? 'error' : ''" :help="primaryIdError">
        <artmisads-input 
          v-model:value="form.primary" 
          placeholder="Enter Primary ID" 
          maxlength="100" 
          :disabled="type=='SUB'"
          @input="validatePrimaryId"
        />
      </a-form-item>
      <a-form-item label="Sub ID" :validate-status="subIdError ? 'error' : ''" :help="subIdError">
        <artmisads-input 
          v-model:value="form.sub" 
          placeholder="Enter Sub ID" 
          maxlength="100"
          @input="validateSubId"
        />
      </a-form-item>
      <div style="text-align: right;">
        <artmisads-select-button class="save-btn" style="width: 120px;" @click="onSave">Save</artmisads-select-button>
      </div>
    </a-form>
  </artmisads-modal>
</template>

<script setup>
import { ref, reactive, watch, defineEmits, defineProps } from 'vue';
import { message } from 'ant-design-vue';

const props = defineProps({
  visible: Boolean,
  type:String,
  primary:String,
  parentId:String
});
const emit = defineEmits(['update:visible', 'save']);

const form = reactive({ primary: '', sub: '' });
const primaryIdError = ref('');
const subIdError = ref('');

watch(() => props.visible, (val) => {
  if (val) {
    form.primary = props.type=='SUB'?props.primary:'';
    form.sub = '';
    primaryIdError.value = '';
    subIdError.value = '';
  }
});

const handleCancel = () => {
  emit('update:visible', false);
};

const handleVisibleChange = (val) => {
  emit('update:visible', val);
};

const validatePrimaryId = (e) => {
  const value = e.target.value;
  if (!value) {
    primaryIdError.value = 'Primary ID is required';
    return;
  }
  if (value.length > 100) {
    primaryIdError.value = 'Exceeds length limit, please enter within 100 characters.';
    return;
  }
  if (!/^[\u4e00-\u9fa50-9A-Za-z]+$/.test(value)) {
    primaryIdError.value = 'Invalid format. Only Chinese characters, letters and numbers are allowed.';
    return;
  }
  primaryIdError.value = '';
};

const validateSubId = (e) => {
  const value = e.target.value;
  if (value.length > 100) {
    subIdError.value = 'Exceeds length limit, please enter within 100 characters.';
    return;
  }
  if (value && !/^[\u4e00-\u9fa50-9A-Za-z]+$/.test(value)) {
    subIdError.value = 'Invalid format. Only Chinese characters, letters and numbers are allowed.';
    return;
  }
  subIdError.value = '';
};

const onSave = () => {
  primaryIdError.value = '';
  
  if (!form.primary) {
    primaryIdError.value = 'Primary ID is required';
    return;
  }
  if (form.primary.length > 100) {
    primaryIdError.value = 'Exceeds length limit, please enter within 100 characters.';
    return;
  }
  if (!/^[\u4e00-\u9fa50-9A-Za-z]+$/.test(form.primary)) {
    primaryIdError.value = 'Invalid format. Only Chinese characters, letters and numbers are allowed.';
    return;
  }
  subIdError.value = '';

  if (form.sub && form.sub.length > 100) {
    subIdError.value = 'Exceeds length limit, please enter within 100 characters.';
    return;
  }
  if (form.sub && !/^[\u4e00-\u9fa50-9A-Za-z]+$/.test(form.sub)) {
    subIdError.value = 'Invalid format. Only Chinese characters, letters and numbers are allowed.';
    return;
  }
  emit('save', { primary:props.type==='PRIMARY'?form.primary:props.parentId, sub: form.sub, trackingIdType:props.type });
};
</script> 
<style lang="less" scoped>
.save-btn{
  background-color: var(--primary);
  color: #fff !important; 
  border-color: var(--primary) !important;
  &:hover{
    background-color: var(--primary-hover) !important;
    border-color: var(--primary-hover) !important;
  }
}
</style>